export const validatePassword = (password, setErrorMessage) => {
    
    const minLength = 12;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (password.length < minLength) {
        setErrorMessage("Le mot de passe doit contenir au moins 12 caractères.");
        return false;
    }
    if (!hasUpperCase) {
        setErrorMessage("Le mot de passe doit contenir au moins une lettre majuscule.");
        return false;
    }
    if (!hasLowerCase) {
        setErrorMessage("Le mot de passe doit contenir au moins une lettre minuscule.");
        return false;
    }
    if (!hasNumber) {
        setErrorMessage("Le mot de passe doit contenir au moins un chiffre.");
        return false;
    }
    if (!hasSpecialChar) {
        setErrorMessage("Le mot de passe doit contenir au moins un caractère spécial.");
        return false;
    }
    setErrorMessage("");
    return true;

}
